import type { QuestionDraft } from './questionTypes'

const LS_KEY = 'brgDebugTestEditImages'

/**
 * В консоли: localStorage.setItem('brgDebugTestEditImages', '1')
 * Снять: localStorage.removeItem('brgDebugTestEditImages')
 * Либо автоматически в development, если подставляет сборщик.
 */
export function isTestEditImageDebugEnabled(): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  try {
    if (window.localStorage?.getItem(LS_KEY) === '1') {
      return true
    }
  } catch {
    /* private mode */
  }
  try {
    return process.env.NODE_ENV === 'development'
  } catch {
    return false
  }
}

function describeApiFilesField(v: unknown): string {
  if (v == null) {
    return 'null/undefined'
  }
  if (Array.isArray(v)) {
    return `array length=${v.length}`
  }
  return typeof v
}

/** Кратко: форма первого вопроса из сырого API (до mapApiQuestionsToReportDrafts). */
export function sampleRawFirstQuestion(questionsPayload: unknown): Record<
  string,
  unknown
> | null {
  if (!Array.isArray(questionsPayload) || questionsPayload.length === 0) {
    return null
  }
  const q0 = questionsPayload[0]
  if (q0 === null || typeof q0 !== 'object') {
    return null
  }
  const rec = q0 as Record<string, unknown>
  const files = rec.files ?? rec.Files
  const opts = rec.answerOptions ?? rec.AnswerOptions
  const opt0 =
    Array.isArray(opts) && opts.length > 0 && opts[0] && typeof opts[0] === 'object'
      ? (opts[0] as Record<string, unknown>)
      : null
  const oFiles = opt0 ? opt0.files ?? opt0.Files : null
  return {
    topKeys: Object.keys(rec).slice(0, 40),
    files: describeApiFilesField(files),
    fileContainerId: rec.fileContainerId ?? rec.FileContainerId ?? null,
    imageKeys: rec.image != null || rec.Image != null ? 'has image/Image' : null,
    firstOptionFiles: opt0 ? describeApiFilesField(oFiles) : 'no options'
  }
}

/**
 * То, что реально используют превью: File → blob URL, иначе imageUrl.
 * Совпадает с QuestionImagePreview / SavedQuestionImageLarge.
 */
export function summarizeQuestionDraftsForDisplay(drafts: QuestionDraft[]) {
  return drafts.map((q, qi) => ({
    index: qi,
    questionId: q.id,
    serverQuestionId: q.serverQuestionId ?? null,
    saved: q.saved,
    questionImage: {
      hasLocalFile: q.imageFile != null,
      remoteUrl: q.imageUrl?.trim() ? q.imageUrl : null,
      fileContainerId: q.questionFileContainerId ?? null,
      /** Покажется ли <img> в форме / сохранённой карточке */
      willRender: Boolean(
        q.imageFile || (q.imageUrl && q.imageUrl.trim().length > 0)
      )
    },
    options: q.options.map((o, oi) => ({
      index: oi,
      optionId: o.id,
      optionImage: {
        hasLocalFile: o.imageFile != null,
        remoteUrl: o.imageUrl?.trim() ? o.imageUrl : null,
        fileContainerId: o.optionFileContainerId ?? null,
        willRender: Boolean(
          o.imageFile || (o.imageUrl && o.imageUrl.trim().length > 0)
        )
      }
    }))
  }))
}

export function logTestEditHydration(
  testItemId: string,
  stage: string,
  detail: Record<string, unknown> | (() => Record<string, unknown>)
): void {
  if (!isTestEditImageDebugEnabled()) {
    return
  }
  const id = testItemId.trim() || '(no id)'
  const resolved = typeof detail === 'function' ? detail() : detail
  // eslint-disable-next-line no-console
  console.groupCollapsed(`[Test edit images] ${stage} testItemId=${id}`)
  // eslint-disable-next-line no-console
  console.log(resolved)
  // eslint-disable-next-line no-console
  console.groupEnd()
}
import type { QuestionDraft } from './questionTypes'

const LS_KEY = 'brgDebugTestEditImages'

/**
 * В консоли: localStorage.setItem('brgDebugTestEditImages', '1')
 * Снять: localStorage.removeItem('brgDebugTestEditImages')
 * Либо автоматически в development, если подставляет сборщик.
 */
export function isTestEditImageDebugEnabled(): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  try {
    if (window.localStorage?.getItem(LS_KEY) === '1') {
      return true
    }
  } catch {
    /* private mode */
  }
  try {
    return process.env.NODE_ENV === 'development'
  } catch {
    return false
  }
}

function describeApiFilesField(v: unknown): string {
  if (v == null) {
    return 'null/undefined'
  }
  if (Array.isArray(v)) {
    return `array length=${v.length}`
  }
  return typeof v
}

/** Кратко: форма первого вопроса из сырого API (до mapApiQuestionsToReportDrafts). */
export function sampleRawFirstQuestion(questionsPayload: unknown): Record<
  string,
  unknown
> | null {
  if (!Array.isArray(questionsPayload) || questionsPayload.length === 0) {
    return null
  }
  const q0 = questionsPayload[0]
  if (q0 === null || typeof q0 !== 'object') {
    return null
  }
  const rec = q0 as Record<string, unknown>
  const files = rec.files ?? rec.Files
  const opts = rec.answerOptions ?? rec.AnswerOptions
  const opt0 =
    Array.isArray(opts) && opts.length > 0 && opts[0] && typeof opts[0] === 'object'
      ? (opts[0] as Record<string, unknown>)
      : null
  const oFiles = opt0 ? opt0.files ?? opt0.Files : null
  return {
    topKeys: Object.keys(rec).slice(0, 40),
    files: describeApiFilesField(files),
    fileContainerId: rec.fileContainerId ?? rec.FileContainerId ?? null,
    imageKeys: rec.image != null || rec.Image != null ? 'has image/Image' : null,
    firstOptionFiles: opt0 ? describeApiFilesField(oFiles) : 'no options'
  }
}

/**
 * То, что реально используют превью: File → blob URL, иначе imageUrl.
 * Совпадает с QuestionImagePreview / SavedQuestionImageLarge.
 */
export function summarizeQuestionDraftsForDisplay(drafts: QuestionDraft[]) {
  return drafts.map((q, qi) => ({
    index: qi,
    questionId: q.id,
    serverQuestionId: q.serverQuestionId ?? null,
    saved: q.saved,
    questionImage: {
      hasLocalFile: q.imageFile != null,
      remoteUrl: q.imageUrl?.trim() ? q.imageUrl : null,
      fileContainerId: q.questionFileContainerId ?? null,
      /** Покажется ли <img> в форме / сохранённой карточке */
      willRender: Boolean(
        q.imageFile || (q.imageUrl && q.imageUrl.trim().length > 0)
      )
    },
    options: q.options.map((o, oi) => ({
      index: oi,
      optionId: o.id,
      optionImage: {
        hasLocalFile: o.imageFile != null,
        remoteUrl: o.imageUrl?.trim() ? o.imageUrl : null,
        fileContainerId: o.optionFileContainerId ?? null,
        willRender: Boolean(
          o.imageFile || (o.imageUrl && o.imageUrl.trim().length > 0)
        )
      }
    }))
  }))
}

export function logTestEditHydration(
  testItemId: string,
  stage: string,
  detail: Record<string, unknown> | (() => Record<string, unknown>)
): void {
  if (!isTestEditImageDebugEnabled()) {
    return
  }
  const id = testItemId.trim() || '(no id)'
  const resolved = typeof detail === 'function' ? detail() : detail
  // eslint-disable-next-line no-console
  console.groupCollapsed(`[Test edit images] ${stage} testItemId=${id}`)
  // eslint-disable-next-line no-console
  console.log(resolved)
  // eslint-disable-next-line no-console
  console.groupEnd()
}
